import * as Sentry from '@sentry/browser';
import { rem } from 'polished';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import styled from 'styled-components';
import Button from '../../components/Button/index';
import Loader from '../../components/Loader';
import PaygateMessages from '../../components/PaygateMessages';
import PaymentTypes from '../../components/PaymentTypes';
import SeatingTable from '../../components/SeatingTable';
import SectionSeparator from '../../components/SectionSeparator';
import { clearState } from '../../localStorage';
import Api from '../../services/api';
import { locale } from '../LocaleProvider';
import { getProp, __ } from '../../utilities';
import { errorAlert, loadPaygateMessages, okAlert } from '../App/actions';
import { paygateMessagesSelector } from '../App/selectors';
import { selectedConnectionDetail } from '../Connections/selectors';
import { userDetailSelector } from '../Login/selectors';
import { BackButton } from '../Passengers';
import {
  formValuesSelector,
  totalPriceSelector,
} from '../Passengers/selectors';
import Summary from '../Summary';
import {
  finalFormatDataSelector,
  reservationsSelector,
  seatingsListSelector,
  ticketIdSelector,
} from './selectors';

const LoaderWrapper = styled.div`
  padding: 2rem 0;
`;

const Content = styled.div`
  max-width: ${rem(700)};
  margin: 0 auto;
`;

const EmailToLoggedUserLabel = styled.label`
  text-align: center;
  display: block;
  margin-top: 1rem;
  padding: 0 1rem;
`;

class SummaryPage extends Component {
  constructor(props) {
    super(props);
    this.finalSubmit = this.finalSubmit.bind(this);
    this.state = {
      selectedBank: null,
      submitInProgress: false,
      paygateMessagesIsFetching: false,
      sendEmailToLoggedUser: false,
    };
  }

  async componentDidMount() {
    const { dispatch } = this.props;
    this.setState({ paygateMessagesIsFetching: true }); // eslint-disable-line react/no-did-mount-set-state
    await dispatch(loadPaygateMessages());
    this.setState({ paygateMessagesIsFetching: false }); // eslint-disable-line react/no-did-mount-set-state
  }

  handleChangePaymentType = newType => {
    if (this.state.selectBank === newType) {
      this.setState({
        selectedBank: null,
      });
    } else {
      this.setState({
        selectedBank: newType,
      });
    }
  };

  finalSubmit() {
    const {
      dispatch,
      toSend,
      location: { query },
      reservations,
    } = this.props;
    if (getProp(query, ['ticketType']) !== 'B') {
      if (!this.state.selectedBank) {
        dispatch(errorAlert('Prosím vyberte spôsob platby'));
        return;
      }
    }
    const addProps = {
      ...toSend,
      bank: this.state.selectedBank,
    };

    const { lang } = locale;

    if (lang) {
      addProps.lang = lang;
    }

    if (getProp(this.props, ['user', 'clientId'])) {
      //
    } else {
      addProps.email = getProp(this.props, [
        'formData',
        'passengers',
        0,
        'email',
      ]);
    }

    if (this.state.sendEmailToLoggedUser) {
      addProps.emailLoggedUser = true;
    }

    this.setState({ submitInProgress: true });
    if (getProp(query, ['ticketType']) === 'B') {
      const data = {
        ticketId: this.props.ticketId,
      };
      const {
        connectionDetail: { sectors },
      } = this.props;
      const sectorsIds = sectors.reduce((prev, sector) => {
        return [...prev, sector.id_dps];
      }, []);
      if (Object.keys(reservations).length > 0) {
        Object.keys(reservations).forEach(r => {
          data.id_dps = r;
          data.id_bus = Object.keys(reservations[r])[0];
          data.seat = reservations[r][data.id_bus][0];

          Api.selectBackWayForOpenTicket(data)
            .then(() => {
              this.setState({ submitInProgress: false });
              clearState();
              dispatch(
                okAlert(__('Spiatočná cesta bola označená'), undefined, () => {
                  window.location = process.env.REACT_APP_API_BASE_URL;
                }),
              );
            })
            .catch(e => {
              Sentry.captureException(e);
              dispatch(
                errorAlert('Vyskytla sa chyba. Prosím skúste to znova.'),
              );
              this.setState({ submitInProgress: false });
            });
          const index = sectorsIds.indexOf(data.id_dps);
          sectorsIds.splice(1, index);
        });
      } else {
        sectorsIds.forEach(sector => {
          data.id_dps = sector;
          data.id_bus = '';
          data.seat = '';
          Api.selectBackWayForOpenTicket(data)
            .then(() => {
              this.setState({ submitInProgress: false });
              clearState();
              dispatch(
                okAlert(__('Spiatočná cesta bola označená'), undefined, () => {
                  window.location = process.env.REACT_APP_API_BASE_URL;
                }),
              );
            })
            .catch(e => {
              Sentry.captureException(e);
              dispatch(
                errorAlert('Vyskytla sa chyba. Prosím skúste to znova.'),
              );
              this.setState({ submitInProgress: false });
            });
        });
      }
    } else {
      Api.createReservation(addProps)
        .then(response => {
          clearState();
          this.commitFormToBank(response.form);
          this.setState({ submitInProgress: false });
        })
        .catch(e => {
          Sentry.captureException(e);
          this.setState({ submitInProgress: false });
          dispatch(errorAlert('Vyskytla sa chyba. Prosím skúste to znova.'));
        });
    }
  }

  commitFormToBank(form) {
    // vytvorime form
    const f = document.createElement('form');
    f.style.display = 'none';
    f.setAttribute('method', 'post');
    f.setAttribute('action', form.targetUrl);

    // vytvorime jednotlive inputy a appendneme ich ku formu
    const params = getProp(form, ['params'], {});
    Object.keys(params).forEach(paramName => {
      const paramValue = params[paramName];
      if (paramValue !== null) {
        const i = document.createElement('input');
        i.setAttribute('type', 'text');
        i.setAttribute('name', paramName);
        i.setAttribute('value', paramValue);
        f.appendChild(i);
      }
    });

    // form musi byt sucastou dokumentu
    document.body.appendChild(f);

    // skusime odpalit
    f.submit();
  }

  render() {
    const {
      paygateMessages,
      location: { query },
    } = this.props;

    if (this.state.submitInProgress) {
      return (
        <LoaderWrapper>
          <Loader size="xl" text={__('Spracúvame požiadavku ...')} />
        </LoaderWrapper>
      );
    }

    if (this.state.paygateMessagesIsFetching) {
      return (
        <LoaderWrapper>
          <Loader size="xl" text={__('Načítavanie ďalších informácií ...')} />
        </LoaderWrapper>
      );
    }

    if (query.ticketType === 'B') {
      return (
        <Content>
          <SectionSeparator
            content={__('Prehľad objednávky pre spiatočnú cestu')}
          />
          <Summary />
          {getProp(this.props, ['seatings'], []).length > 0 && (
            <SectionSeparator content={__('Miestenky')} />
          )}
          <SeatingTable seatings={this.props.seatings} />
          <SectionSeparator
            content={[
              <BackButton basic primary onClick={this.props.backStep}>
                {__('Späť')}
              </BackButton>,
              <Button primary onClick={this.finalSubmit}>
                {__('Záväzne označiť lístok pre spiatočnú cestu')}
              </Button>,
            ]}
          />
        </Content>
      );
    }

    const loggedUserEmail = getProp(this.props, ['user', 'email']);
    const emailFromForm = getProp(this.props, [
      'formData',
      'passengers',
      0,
      'email',
    ]);

    return (
      <Content>
        <SectionSeparator content={__('Prehľad objednávky')} />
        <Summary />
        {getProp(this.props, ['seatings'], []).length > 0 && (
          <SectionSeparator content={__('Miestenky')} />
        )}
        <SeatingTable seatings={this.props.seatings} />
        <PaygateMessages messages={paygateMessages} />
        <SectionSeparator content={__('Spôsob platby')} />
        <PaymentTypes
          value={this.state.selectedBank}
          onChange={this.handleChangePaymentType}
        />
        {loggedUserEmail !== '' && loggedUserEmail !== emailFromForm && (
          <EmailToLoggedUserLabel htmlFor="sendEmailToLoggedUser">
            <input
              id="sendEmailToLoggedUser"
              type="checkbox"
              checked={this.state.sendEmailToLoggedUser}
              onChange={ev => {
                this.setState({ sendEmailToLoggedUser: ev.target.checked });
              }}
            />
            {`${__(
              'Zaslať informačný e-mail o rezervácii aj na',
            )} "${loggedUserEmail}"`}
          </EmailToLoggedUserLabel>
        )}
        <SectionSeparator
          content={[
            <BackButton basic primary onClick={this.props.backStep}>
              {__('Späť')}
            </BackButton>,
            <Button primary onClick={this.finalSubmit}>
              {__('Záväzne objednať s povinnosťou platby')}
            </Button>,
          ]}
        />
      </Content>
    );
  }
}

SummaryPage.propTypes = {
  paygateMessages: PropTypes.arrayOf(
    PropTypes.shape({
      message: PropTypes.string,
    }),
  ).isRequired,
  backStep: PropTypes.func.isRequired,
  toSend: PropTypes.shape({}).isRequired,
  ticketId: PropTypes.string,
  seatings: PropTypes.arrayOf(PropTypes.shape({})),
  dispatch: PropTypes.func.isRequired,
};

SummaryPage.defaultProps = {
  ticketId: null,
  seatings: [],
};

const mapStateToProps = state => {
  return {
    totalPrice: totalPriceSelector(state),
    seatings: seatingsListSelector(state),
    toSend: finalFormatDataSelector(state),
    user: userDetailSelector(state),
    formData: formValuesSelector(state),
    connectionDetail: selectedConnectionDetail(state),
    ticketId: ticketIdSelector(state),
    reservations: reservationsSelector(state),
    paygateMessages: paygateMessagesSelector(state),
  };
};

const summaryWithRouter = withRouter(SummaryPage);
export default connect(mapStateToProps)(summaryWithRouter);



// WEBPACK FOOTER //
// ./src/containers/SummaryPage/index.js